import React from "react";
import img from "../../assets/team/team2.png";
function Monika() {
  return (
    <div className="bg-[#FFEEEF] w-full flex justify-center items-center py-11">
      <div className="max-w-[1440px] flex justify-between flex-col-reverse lg:flex-row items-center px-10 w-full gap-10">
        <img src={img} alt="" />
        <div className="flex justify-center text-justify flex-col items-start gap-4">
          <h1 className="font-bold text-lightGreen-500 text-3xl md:text-5xl">
            Dr. Monika Suchowierska-Stephany
          </h1>
          <h2 className="font-bold text-lightGreen-500 text-xl md:text-2xl">
            Ph.D., BCBA-D 
          </h2>
          <p className="font-normal text-justify text-lightGreen-500 text-lg lg:max-w-[680px]">
            Dr. Suchowierska-Stephany earned her Ph.D. in{" "}
            <span className="font-mono">2003</span> from the University of
            Kansas.
          </p>
          <p className="font-normal text-justify text-lightGreen-500 text-lg lg:max-w-[680px]">
            She has over <span className="font-mono">20</span> years of
            experience working with children with autism and other developmental
            disabilities.
          </p>
          <p className="font-normal text-justify text-lightGreen-500 text-lg lg:max-w-[680px]">
            She is a highly respected clinician and trainer. Dr. Suchowierska-Stephany, has authored three books and 
            numerous articles on applied behavior analysis and autism treatment. 
          </p>
          {/* <p className="font-normal text-lightGreen-500 text-lg lg:max-w-[680px]">
            Dr. Suchowierska-Stephany is also an Associate Professor and the
            Director of the Clinical Psychology Program at University of Social
            Science and Humanities in Warsaw.
          </p> */}
        </div>
      </div>
    </div>
  );
}

export default Monika;
